module.exports = "/_next/static/images/madeline-nelson-7c6e2dfbab60acb7d436f9c0fdc32e5e.jpg";